(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-mv_slider"] && !Shopify.designMode) return;
  try {
    
  // TOP slider
new Swiper('.slider_top', {
  loop: true,
  speed: 2000,
  slidesPerView: 1,
  spaceBetween: 15,
  centeredSlides: true,

  breakpoints: {
    769: {
      slidesPerView: 1.8,
      spaceBetween: 25,
    }
  },

  autoplay: {
    delay: 3500,
    disableOnInteraction: false,
  },

  pagination: {
    el: ".mv_slider-pagination",
    clickable: true
  },

  navigation: {
    nextEl: ".mv_slider-button-next",
    prevEl: ".mv_slider-button-prev"
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-custom"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('.swiper');
  if (!slider) return;
  
  const autoplaySpeed = parseInt(slider.dataset.autoplaySpeed);
  const showPagination = slider.dataset.showPagination === 'true';
  const effect = slider.dataset.effect;
  const slidesPerView = parseInt(slider.dataset.slidesPerView);
  const slidesPerViewTablet = parseInt(slider.dataset.slidesPerViewTablet);
  const slidesPerViewMobile = parseInt(slider.dataset.slidesPerViewMobile);
  const spaceBetween = parseInt(slider.dataset.spaceBetween);
  const arrowColor = slider.dataset.arrowColor;
  const arrowBackground = slider.dataset.arrowBackground;
  const arrowSize = parseInt(slider.dataset.arrowSize);
  const totalSlides = document.querySelectorAll('.swiper-slide').length;

  // スライド数と表示枚数が同じ場合は矢印を非表示にするスタイルを追加
  const hideArrowsStyle = document.createElement('style');
  if (totalSlides <= slidesPerView) {
    hideArrowsStyle.textContent = `
      .swiper-button-next,
      .swiper-button-prev {
        display: none !important;
      }
    `;
    document.head.appendChild(hideArrowsStyle);
  }

  // カスタムアロースタイルの適用
  const style = document.createElement('style');
  style.textContent = `
    .swiper-button-next:after,
    .swiper-button-prev:after {
      width: ${arrowSize}px;
      height: ${arrowSize}px;
      border-bottom: ${arrowColor} 1px solid;
      border-left: ${arrowColor} 1px solid;
    }
  `;
  document.head.appendChild(style);

  new Swiper('.swiper', {
    effect: effect === 'fade' || effect === 'cube' ? effect : 'slide',
    slidesPerView: slidesPerView,
    spaceBetween: spaceBetween,
    loop: totalSlides > slidesPerView,
    autoplay: totalSlides > slidesPerView ? {
      delay: autoplaySpeed,
      disableOnInteraction: false,
    } : false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      enabled: showPagination && totalSlides > slidesPerView
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    grabCursor: totalSlides > slidesPerView,
    keyboard: {
      enabled: totalSlides > slidesPerView,
    },
    breakpoints: {
      320: {
        slidesPerView: parseInt(slidesPerViewMobile),
      },
      768: {
        slidesPerView: slidesPerViewTablet,
      },
      1024: {
        slidesPerView: slidesPerView,
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
